import { useEffect } from "react";
import { useLocation, useParams } from "react-router";
import { Box } from "@mui/material";
import { Form, Formik, FormikHelpers } from "formik";

import { PanelDetailContent as RightContent } from "components/PanelDetailContent";
import { PanelSidebar } from "components/PanelSidebar";
import Page from "components/wrappers/Page";
import { CUSTOM_PANELS } from "helpers/apis";
import useAxios from "helpers/axios";
import useCatalogDetail from "hooks/useCatalogDetail";
import { validationSchema } from "pages/evaluate-panel-options";
import { ICustomPanelForm } from "types/form";
import { ICustomPanel } from "types/panel";

export const DraftCustomPanelDetail = ({
  customize = false,
}: {
  customize?: boolean;
}) => {
  const { id: customPanelId } = useParams<{ id: string }>();
  const { pathname } = useLocation();
  let {
    catalog,
    customPanelAction,
    fetchDesignDetails,
    setCatalog,
    setCustomize,
    setDraftSaved,
    setIsCustomPanel,
  } = useCatalogDetail();
  let customPanel = catalog as any as ICustomPanel;

  const { fetchData } = useAxios({
    config: {
      method: "GET",
    },
    callOnInit: false,
  });

  useEffect(() => {
    fetchData(
      {
        url: `${CUSTOM_PANELS}${customPanelId}`,
      },
      ({
        response: { data },
      }: {
        response: {
          data: ICustomPanel;
        };
      }) => {
        setCatalog(data);
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customPanelId]);

  useEffect(() => {
    if (
      !!customPanel &&
      Array.isArray(customPanel.panelspresent) &&
      !!customPanel.panelspresent.length
    ) {
      // Set new details for custom panels
      fetchDesignDetails(
        customPanel.panelspresent.map((item: any) => {
          return {
            panelId: item.design,
            cnv: item.cnv,
          };
        })
      );
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [customPanel?.panelspresent, fetchDesignDetails]);

  useEffect(() => {
    setCustomize(customize);
    setIsCustomPanel(true);
    setCatalog(customPanel);
    setDraftSaved(customPanel);
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [pathname, customPanel]);

  if (!customPanel || Number(customPanelId) !== customPanel.id) {
    return <></>;
  }

  const onSubmit = (
    values: ICustomPanelForm,
    actions: FormikHelpers<ICustomPanelForm>
  ) => {
    customPanelAction({
      values,
      actions,
      config: {
        url: customize ? `${CUSTOM_PANELS}${customPanel?.id}/` : CUSTOM_PANELS,
        method: customize ? "PUT" : "POST",
      },
    });
  };

  return (
    <Box width={1}>
      <Formik
        initialValues={{
          panelName: customPanel.name || "",
          panels: [],
          ...(typeof customPanel.hasMsi === "boolean" && {
            msi: customPanel.hasMsi,
          }),
          ...(typeof customPanel.hasMsi === "boolean" && {
            snpId: customPanel.hasSnpId,
          }),
        }}
        enableReinitialize
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        <Form>
          <Page>
            <PanelSidebar />
            <RightContent />
          </Page>
        </Form>
      </Formik>
    </Box>
  );
};
